import { render, staticRenderFns } from "./host.vue?vue&type=template&id=c73714aa&scoped=true&"
import script from "./host.vue?vue&type=script&lang=js&"
export * from "./host.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c73714aa",
  null
  
)

export default component.exports